export const square = {
    method: 'GET',
    paths: ['/redirect/square'],
    fields: {
        code: {
            type: 'keyString',
            required: true,
        },
        state: {
            type: 'keyString',
            required: true,
        },
    },
};
//# sourceMappingURL=oauth_square.js.map